import { motion } from 'framer-motion';
import { FaCode, FaWordpress, FaSearch, FaServer, FaCheckCircle } from 'react-icons/fa';

const About = ({ profile }) => {
  const highlights = [
    { icon: <FaCode />, label: 'MERN Stack', color: '#61DAFB' },
    { icon: <FaWordpress />, label: 'WordPress', color: '#21759B' },
    { icon: <FaSearch />, label: 'SEO Expert', color: '#4caf50' },
    { icon: <FaServer />, label: 'Full Stack', color: '#ff6584' }
  ];

  const checklist = [
    'Custom Web Application Development',
    'Responsive & Mobile-First Design',
    'E-Commerce Solutions (WooCommerce)',
    'Search Engine Optimization (SEO)',
    'REST API Design & Integration',
    'Website Speed & Performance Optimization'
  ];

  return (
    <section className="about section" id="about">
      <div className="container">
        <div className="section-title">
          <h2>About Me</h2>
          <p>Know more about my expertise and journey</p>
        </div>
        <div className="about-content">
          <motion.div className="about-image"
            initial={{ opacity: 0, x: -50 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}>
            <div className="about-image-wrapper">
              <div className="placeholder">
                <div className="about-avatar-text">A</div>
              </div>
              {/* Floating badges */}
              <div className="about-badges">
                {highlights.map((h, i) => (
                  <motion.div key={i} className="about-badge"
                    initial={{ opacity: 0, scale: 0 }} whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: true }} transition={{ delay: 0.3 + i * 0.15 }}
                    style={{ '--badge-color': h.color, animationDelay: `${i * 0.5}s` }}>
                    <span style={{ color: h.color, fontSize: '1.2rem' }}>{h.icon}</span>
                    <span>{h.label}</span>
                  </motion.div>
                ))}
              </div>
            </div>
          </motion.div>

          <motion.div className="about-text"
            initial={{ opacity: 0, x: 50 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}>
            <h3>Hi, I'm {profile?.name || 'Asif'} — a passionate developer who builds digital experiences</h3>
            <p>
              {profile?.bio || "I'm a Full Stack Web Developer specialized in the MERN Stack (MongoDB, Express.js, React.js, Node.js), WordPress Development, and SEO. I help businesses grow online with custom web solutions, e-commerce stores, and strategic SEO services."}
            </p>
            <p>
              With expertise across the full development spectrum — from pixel-perfect frontends to robust backends, WordPress customization to search engine optimization — I deliver complete, production-ready solutions that drive results.
            </p>

            {/* Checklist */}
            <div className="about-checklist">
              {checklist.map((item, i) => (
                <motion.div key={i} className="check-item"
                  initial={{ opacity: 0, x: 20 }} whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }} transition={{ delay: i * 0.1 }}>
                  <FaCheckCircle style={{ color: 'var(--accent)', flexShrink: 0 }} />
                  <span>{item}</span>
                </motion.div>
              ))}
            </div>

            <div className="about-stats">
              <div className="stat-item"><h4>3+</h4><p>Years Experience</p></div>
              <div className="stat-item"><h4>50+</h4><p>Projects Done</p></div>
              <div className="stat-item"><h4>30+</h4><p>Happy Clients</p></div>
              <div className="stat-item"><h4>100%</h4><p>Satisfaction</p></div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;
